import { z } from 'zod';

export const attentionUserSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const attentionUsersResponseSchema = z.array(attentionUserSchema);

export type AttentionUser = z.infer<typeof attentionUserSchema>;
export type AttentionUsersResponse = z.infer<
  typeof attentionUsersResponseSchema
>;
